/**
 * CLIENTELE – Cart JS (Phase 5)
 * Silent fetch-based qty update + remove, with optimistic UI and error rollback
 */
(function () {
  'use strict';

  var cart = document.querySelector('.cl-cart');
  if (!cart) return;

  /* ── QTY & REMOVE BUTTONS ── */
  cart.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-key][data-qty]');
    if (!btn) return;
    e.preventDefault();

    var key = btn.dataset.key;
    var qty = parseInt(btn.dataset.qty, 10);
    updateItem(key, qty, btn);
  });

  function updateItem(key, qty, triggerEl) {
    var itemEl = triggerEl.closest('.cl-cart__item');
    if (!itemEl) return;

    // Optimistic UI
    itemEl.classList.add('is-updating');
    var checkoutBtn = document.querySelector('.cl-cart__checkout-btn');
    if (checkoutBtn) checkoutBtn.disabled = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Cart update failed');
      return r.json();
    })
    .then(function (updatedCart) {
      // Reload page to reflect server-rendered Liquid (keeps Liquid-side free-ship calc accurate)
      window.location.reload();
    })
    .catch(function () {
      itemEl.classList.remove('is-updating');
      if (checkoutBtn) checkoutBtn.disabled = false;
    });
  }

})();
